/**
 *
 * Asynchronously loads the component for PersonalAccessTokens
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PersonalAccessTokens = lazyLoad(
  () => import('./index'),
  module => module.PersonalAccessTokens
);
